import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import ContattiShortComp from "../../Contatti/ContattiShortComp";

// @material-ui/icons
import AvTimer from "@material-ui/icons/AvTimer";
import EuroSymbol from "@material-ui/icons/EuroSymbol";
import EmojiEvents from "@material-ui/icons/EmojiEvents";
import People from "@material-ui/icons/People";
import ListAlt from "@material-ui/icons/ListAlt";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Link from "@material-ui/core/Link";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Typography from "@material-ui/core/Typography";

import styles from "../pacchettiStyle.js";
import TeatroPerDTImage from "../../../assets/img/TeatroPerDT.jpg";

const useStyles = makeStyles(styles);

export default function TeatroPerDTSection() {
	const [expanded, setExpanded] = React.useState(false);

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};

	const classes = useStyles();
	const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
	return (
		<div className={classes.sectionAlternate}>
			<GridContainer justify="center">
				<GridItem xs={12} sm={12} md={10}>
					<h2 className={classes.title + " " + classes.textColorAlternate}>
						Teatro per il Design Thinking
					</h2>
					<GridContainer justify="center">
						<GridItem xs={12} sm={12} md={4}>
							<List>
								<ListItem alignItems="flex-start">
									<ListItemAvatar>
										<AvTimer color="error" fontSize="large" />
									</ListItemAvatar>
									<ListItemText
										disableTypography
										secondary={
											<React.Fragment>
												<Typography
													component="div"
													variant="h6"
													className={classes.textColorAlternate}
												>
													{"Durata: "}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoce +
														" " +
														classes.textColorAlternate
													}
												>
													{"2 giornate (in presenza)"}
												</Typography>
											</React.Fragment>
										}
									/>
								</ListItem>
								<hr className={classes.hrMargin} />
								{/* <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <EuroSymbol
                      className={classes.successColor}
                      fontSize="large"
                    />
                  </ListItemAvatar>
                  <ListItemText
                    disableTypography
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="div"
                          variant="h6"
                          className={classes.textColorAlternate}
                        >
                          {"Costo: "}
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          className={
                            classes.descrizioneVoce +
                            " " +
                            classes.textColorAlternate
                          }
                        >
                          {"1.200 + IVA per gruppo"}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItem> */}
								{/* <hr className={classes.hrMargin} /> */}
								<ListItem alignItems="flex-start">
									<ListItemAvatar>
										<EmojiEvents
											className={classes.warningColor}
											fontSize="large"
										/>
									</ListItemAvatar>
									<ListItemText
										disableTypography
										secondary={
											<React.Fragment>
												<Typography
													component="div"
													variant="h6"
													className={classes.textColorAlternate}
												>
													{"Obiettivi: "}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Utilizzare alcune tecniche di formazione dell’attore non per diventare attori ma per praticare con più agio il "
													}
													<Link href="/metodi/designthinking" color="error">
														Design Thinking
													</Link>
													{"."}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Migliorare la propensione all’ascolto dei clienti esterni e interni nelle fasi di indagine e test."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Gestire contemporaneamente azione e ascolto nella presentazione dei prototipi."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Stimolare un atteggiamento di sperimentazione continua."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Lavorare in team offrendo le proprie idee e costruendo sulle idee degli altri."
													}
												</Typography>
											</React.Fragment>
										}
									/>
								</ListItem>
								<hr className={classes.hrMargin} />
							</List>
						</GridItem>
						<GridItem xs={12} sm={12} md={4}>
							<List>
								<ListItem alignItems="flex-start">
									<ListItemAvatar>
										<People style={{ color: "#ddd" }} fontSize="large" />
									</ListItemAvatar>
									<ListItemText
										disableTypography
										secondary={
											<React.Fragment>
												<Typography
													component="div"
													variant="h6"
													className={classes.textColorAlternate}
												>
													{"Destinatari: "}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{"Persone e team con conoscenze di base del "}
													<Link href="/metodi/designthinking" color="error">
														Design Thinking
													</Link>
													{"."}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Team aziendali impegnati in progetti di innovazione con il Design Thinking."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Tutte le persone interessate ad una applicazione efficace del Design Thinking."
													}
												</Typography>
											</React.Fragment>
										}
									/>
								</ListItem>
								<hr className={classes.hrMargin} />
								<ListItem alignItems="flex-start">
									<ListItemAvatar>
										<ListAlt className={classes.infoColor} fontSize="large" />
									</ListItemAvatar>
									<ListItemText
										disableTypography
										secondary={
											<React.Fragment>
												<Typography
													component="div"
													variant="h6"
													className={classes.textColorAlternate}
												>
													{"Programma: "}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Esposizione sintetica dei principi e delle 5 fasi del "
													}
													<Link href="/metodi/designthinking" color="error">
														Design Thinking
													</Link>
													{"."}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Esercizi di riscaldamento e di affiatamento di gruppo."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Presentazione e pratica di tecniche teatrali specifiche per ognuna delle 5 fasi."
													}
												</Typography>
												<Typography
													component="div"
													variant="body1"
													className={
														classes.descrizioneVoceLista +
														" " +
														classes.textColorAlternate
													}
												>
													{
														"Applicazione degli strumenti sperimentati ad un progetto di prova."
													}
												</Typography>
											</React.Fragment>
										}
									/>
								</ListItem>
								<hr className={classes.hrMargin} />
								<ContattiShortComp textColor="#fff" align="right" alternate />
							</List>
						</GridItem>
						<GridItem xs={12} sm={12} md={4}>
							<img
								alt="Teatro per il Design Thinking"
								title="Teatro per il Design Thinking"
								src={TeatroPerDTImage}
								className={navImageClasses}
							/>
						</GridItem>
					</GridContainer>
				</GridItem>
			</GridContainer>
		</div>
	);
}
